<template>
    <div class="evaluate">

<!-- 1. 预约信息记录 -->
        <!-- <div class="top"> <span class="msg">预约信息记录</span> </div> -->

<!-- 没有记录 -->
        <div class="noNews" v-if="this.msgs.length == 0">
            <img src="../assets/four/bq-his.png">
            <p>未查询到您的预约信息</p>
        </div>

<!-- 信息 -->
        <div class="msgs" v-for="(item,i) of msgs" :key="i" @click="getInfo(item)">
            <msgItem :item="item"></msgItem>
        </div>

<!-- 预约二维码 -->
        <showcode :sucResult="sucResult" :tocancel="tocancel" v-if="success" @cancelSuc="cancelSuc"></showcode>
    </div>
</template>


<script>

import msgItem from '../components/three/preMsg';
import showcode from '../components/one/preCode';
import { getMsg } from '../tools/get';
import { request } from '../network/request';
import { Loading, Toast } from 'vant';
import Vue from 'vue';

export default {
    components:{ msgItem, showcode },
    inject:['reload'],
    data(){
        return {
            msgs: [], // 传值给 preMsg
            varval: '', // 接收 queryNews 传值，发送 ajax
            success: false, // 二维码 显示隐藏
            sucResult: {}, // 二维码给 preCode 传值
            base64_img: "",
            isShow: false, // 未查询到预约信息
            tocancel: true
        }
    },
    created(){
        this.bus.$on('prequery', this.prequery)  // 1. 预约记录，给 data 赋值
        this.pres();                            // 2. 预约记录
        this.bus.$on('closeNew', this.closeNew)  // 3. 关闭二维码SS
        document.body.style.background = "#EEEEEE";
    },
    methods:{
    // 取消成功
    cancelSuc(){
      this.success = false;
      this.pres();
    },

        // 1. 传参，给 data 赋值，请求 预约记录
        prequery(data){ this.varval = data; },

    // 2. 预约记录
    pres(){
        let data = '';
        request().then(result => {
        data = result.data.info;
		if(data.midel == ""){
			data.midel = sessionStorage.getItem('mobile');
		}
		if(data.idno == ""){
			data.idno = sessionStorage.getItem('idNo');
		}
		if(data.type == ""){
			data.type = sessionStorage.getItem('type');
		}
        this.reqDataList(data)
        })
    },

    reqDataList(data) {

            var url = '';
            var obj = {
                        "cmd": "yuyuequery",
                        "openId": data.openid,
                        "type": data.type,
                        "mobile": data.midel,
                        "idNo": data.idno,
                        search: this.varval             // 用户输入信息
					 };
					 
					 if(localStorage.getItem("type")) {
			obj.type = localStorage.getItem("type");
		}
            getMsg(url,obj).then(result => {

                console.log('响应 - 成功')
                console.log(result)

                if(result.status == 200){
                    if(result.data.result == 0){
                        this.msgs = result.data.data;   // 传值给 preMsg 组件
                    }
                    else if(result.data.status == 301) { Toast(result.data.errdesc); this.isShow = true; console.log('行为不存在') }
                    else if(result.data.status == 302) { Toast(result.data.errdesc); this.isShow = true; console.log('数据库操作失败') }
                    else if(result.data.status == 303) { Toast(result.data.errdesc); this.isShow = true; console.log('用户没有登录') }
                    else if(result.data.status == 305) { Toast(result.data.errdesc); this.isShow = true; console.log('参数错误') }
                    else if(result.data.status == 304) { Toast(result.data.errdesc); this.isShow = true; console.log('网站黑名单') }
                    else if(result.data.status == 306) { Toast(result.data.errdesc); this.isShow = true; console.log('数据不存在') }
                    else if(result.data.status == 307) { Toast(result.data.errdesc); this.isShow = true; console.log('当前条件下不符合要求') }
                    else{ Toast(result.data.errdesc); this.isShow = true; console.log(result.data.errdesc) }
                }
                else { Toast(result.data.errdesc); this.isShow = true; console.log('请求失败') }
            }).catch( err => { console.log(err) } )
        },

// 3. 关闭弹出框信息
        closeNew(n){
            this.success = false;
            this.pres()     // 2. 预约记录
        },

// 4. 弹出预约信息
        getInfo(item){
            console.log(item)
            if(item.Status == 1){
                this.sucResult = {                        // 预约成功 响应结果
                        "reservNo": item.yynumber,        // 预约号码
                        "phone": item.mobile,             // 手机号
                        "bussName": item.job_name,        // 预约业务
                        "reservDate": item.ymd,           // 日期
                        "startTime": item.start_time,     // 开始时间
                        "endTime": item.end_time          // 结束时间
                        };
                        this.success = true;
            }
            else if(item.Status == 2) { Toast.success('该预约已取消') }
            else if(item.Status == 3) { Toast.success('该预约已出票') }
            else if(item.Status == 4) { Toast.success('该预约已失效') }
            else { Toast('该预约已失效') }
        }
    }
}
</script>


<style scoped>
    *{
        color: #666;
        font-family: Microsoft YaHei;
        padding: 0;
        margin: 0;
    }

    input::placeholder {
        color:#aaa;
    }

    .evaluate {
        width: calc(100% - 20px);
        padding: 0 10px;
        padding-bottom: 50px;
        background:#eee;
    }

    .top {
        width: 100%;
        height: 40px;
        background-image: linear-gradient(to bottom,#0984e4,#15b8f2);
    }
    .top>span {
        line-height: 40px;
        color: rgba(255,255,255,0.9);
        margin-left: 10px;
        }

    .msgs {
        width: 100%;
        }

/* 没有预约 */
    .noNews {
        position: absolute;
        left: 10px;
        top: 80px;
        bottom: 10px;
        right: 10PX;
        background: #FFF;
        display: flex;
        align-items: center;
        flex-direction: column;
        }

    .noNews>img {
        width: 166px;
        height: 91px;
        margin-top: 100px;
        }

    .noNews>p {
        margin-top: 20px;
        color: #999;
        }
</style>
